import React from "react";
import PropTypes from "prop-types";
import { Title } from "rbx";
import { WorkOrderPartItem } from "../../../../components/WorkOrders";

function Part({
  WorkOrder,
  handleChange,
  removeRow,
  Parts,
  loading,
  companySettings,
  PrimaryStorageDimension,
  SecondaryStorageDimension,
  TertiaryStorageDimension,
  UsePrimaryStorageDimension,
  UseSecondaryStorageDimension,
  UseTertiaryStorageDimension
}) {
  return (
    <React.Fragment>
      {Parts && Parts.length > 0 ? (
        Parts.map((item, i) => (
          <WorkOrderPartItem
            AddButton={i === Parts.length - 1}
            PrimaryStorageDimension={PrimaryStorageDimension}
            SecondaryStorageDimension={SecondaryStorageDimension}
            TertiaryStorageDimension={TertiaryStorageDimension}
            UsePrimaryStorageDimension={UsePrimaryStorageDimension}
            UseSecondaryStorageDimension={UseSecondaryStorageDimension}
            UseTertiaryStorageDimension={UseTertiaryStorageDimension}
            WorkOrder={WorkOrder}
            companySettings={companySettings}
            disabled={loading || WorkOrder.PartsApproved}
            handleChange={handleChange(i)}
            item={item}
            key={item.RecId}
            removeRow={() => removeRow(i, item)}
          />
        ))
      ) : (
        <Title subtitle>No Parts Added</Title>
      )}
    </React.Fragment>
  );
}

Part.propTypes = {
  WorkOrder: PropTypes.object,
  handleChange: PropTypes.func,
  loading: PropTypes.bool,
  removeRow: PropTypes.func,
  Parts: PropTypes.array,
  companySettings: PropTypes.object,
  PrimaryStorageDimension: PropTypes.object,
  SecondaryStorageDimension: PropTypes.object,
  TertiaryStorageDimension: PropTypes.object,
  UsePrimaryStorageDimension: PropTypes.bool,
  UseSecondaryStorageDimension: PropTypes.bool,
  UseTertiaryStorageDimension: PropTypes.bool
};
export default Part;
